<ng-container *ngIf="service$ | async as service; else loading">
<ng-container *ngIf="real$ | async as real">
  <ion-header class="header" mode="md">
    <ion-grid fixed class="ion-no-padding">
      <ion-toolbar mode="md">
        <ion-title class="ion-text-center header-title">
          {{ service?.name | ppTranslate:service?.nameTranslations:translateService.currentLang }} 
        </ion-title>
        <ion-buttons slot="start" class="header-buttons" style="margin-left:-6px">
          <ion-button [routerLink]="real?.getUrlArr( true )" class="header-buttons__btn">
            <ion-icon name="arrow-back-sharp" slot="icon-only" shape="round"></ion-icon>
          </ion-button>
        </ion-buttons>
        <app-top-right slot="end"></app-top-right>
      </ion-toolbar>
    </ion-grid>
  </ion-header>

  <ion-content [style.border-color]="'#0100ee'" style="border-top:4px solid #0100ee;" min="0" max="2400" color="white" class="ion-padding profile">
    <ion-grid fixed class="ion-no-padding">
      <div class="ion-padding profile__picture" *ngIf="service?.avatar?.document?.fileName">
        <img [src]="service?.avatar?.document?.fileName | ppImage" alt="{{ service?.name }}">
      </div>

            
      

      <div class="ion-padding profile__info" style="padding-bottom:0px;">
        <h5>{{ service?.shortName | ppTranslate:service.shortNameTranslations:translateService.currentLang }}</h5>
        <h1 style="margin-top:15px;">
          {{ service?.name | ppTranslate:service?.nameTranslations:translateService.currentLang }}
        </h1>
        <p>{{ service?.descriptionButtonText | ppTranslate:service.descriptionButtonTextTranslations:translateService.currentLang }}</p>
        <div class="clickable ion-text-right" style="margin-top:20px; margin-bottom: 20px;">
        <ion-button *ngIf="real" style="font-size: 13px;" class="ion-float-right" color="primary" (click)="goToPickSlot(real, service);" class="btn--large ion-no-margin">{{ 'SHOP_DETAIL.BTN_BOOK' | translate }}&nbsp;<ion-icon style="color: white" name="calendar-outline"></ion-icon></ion-button>
      </div>
        <br/>
        <p *ngIf="service?.longDescription" [innerHTML]="service?.longDescription | ppTranslate:service?.longDescriptionTranslations:translateService.currentLang"></p>
      </div>



      <ng-container *ngFor="let service of service?.children">
        <ion-item  *ngIf="service.visibleForCustomers"> <!-- class="clickable" (click)="toggleService( service, category )"-->
            <ion-grid  class="ion-no-padding">
              <ion-row class="ion-no-padding ion-align-items-start services-list-row">
                <!--ion-col size="1">
                  &bull;
                  ion-checkbox name="cb-2" mode="md" [checked]="isServicePicked(service)"></ion-checkbox
                </ion-col-->
                <ion-col size="8" class="services-list-row__item-name" style="font-size:1.2em; padding-top:5px; padding-bottom:5px;"><strong>{{ service.name | ppTranslate:service.nameTranslations:translateService.currentLang }}</strong></ion-col>
                <ion-col size="4" class="ion-text-right services-list-row__item-price">
                  

                  <span class="services-list-row__item-discount"></span>
                  <span *ngIf="service.minimalPrice.varyPrices">{{ 'EVENT_CARD.FROM' | translate }} </span><span *ngIf="service.minimalPrice.lowestPrice">{{ service.minimalPrice.lowestPrice | currency: 'EUR' }}</span>
                  
                </ion-col>


                <!--ion-col size="1"></ion-col-->
                <ion-col *ngIf="false" size="8" class="services-list-row__item-time">
                {{  ( service.duration / 60 ) | number:'1.0-0' }} min
                </ion-col>
                <ion-col *ngIf="false" size="3" class="ion-text-right services-list-row__list-icon">
                  <ion-icon name="list" mode="ios"></ion-icon>
                </ion-col>
              </ion-row>
              <!-- && isServicePicked(service) -->
              <ion-row *ngIf="service.longDescription" class="services-list-row__item-expanded-info ion-align-items-start">
                <!--ion-col size="1"></ion-col-->
                <ion-col size-xs="3" size-md="2" *ngIf="service.avatar?.document?.fileName">
                  <img class="ion-float-left" style="width: 100%; padding: 0px 16px 0px 0px"  [src]="service.avatar?.document?.fileName | ppImage" />
                </ion-col>
                <ion-col size-xs="9" size-md="10">
                  <p class="formatted" innerHtml="{{ service.longDescription | ppTranslate:service.longDescriptionTranslations:translateService.currentLang }}"></p>
                </ion-col>
              </ion-row>
            </ion-grid>
          </ion-item>
      </ng-container>

      <div class="ion-float-right clickable" style="margin-top:20px; padding-bottom: 20px;">
        <ion-button *ngIf="real" style="font-size: 13px;" class="ion-float-right" color="primary" (click)="goToPickSlot(real, service);" class="btn--large ion-no-margin">{{ 'SHOP_DETAIL.BTN_BOOK' | translate }}&nbsp;<ion-icon style="color: white" name="calendar-outline"></ion-icon></ion-button>
      </div>

    </ion-grid>

  </ion-content>



</ng-container>
</ng-container>

<ng-template #loading>
  <ion-header class="header" mode="md">
    <ion-grid fixed class="ion-no-padding">
      <ion-toolbar mode="md">
        <ion-title class="ion-text-center header-title"></ion-title>
        <ion-buttons slot="start" class="header-buttons" style="margin-left:-6px">
          <ion-button [routerLink]="'/kulinaricne-delavnice'" class="header-buttons__btn">
            <ion-icon name="arrow-back-sharp" slot="icon-only" shape="round"></ion-icon>
          </ion-button>
        </ion-buttons>
        <app-top-right slot="end"></app-top-right>
      </ion-toolbar>
    </ion-grid>
  </ion-header>

  <ion-content class="ion-padding">
    <ion-grid fixed>
      <ion-skeleton-text animated style="width: 60%; height: 32px; margin-bottom: 12px;"></ion-skeleton-text>
      <ion-skeleton-text animated style="width: 100%; height: 200px; margin-bottom: 16px;"></ion-skeleton-text>
      <ion-skeleton-text animated style="width: 90%; height: 16px; margin-bottom: 8px;"></ion-skeleton-text>
      <ion-skeleton-text animated style="width: 80%; height: 16px; margin-bottom: 8px;"></ion-skeleton-text>
      <ion-skeleton-text animated style="width: 70%; height: 16px; margin-bottom: 8px;"></ion-skeleton-text>

      <ion-item *ngFor="let i of [1,2,3]" lines="full">
        <ion-label>
          <ion-skeleton-text animated style="width: 60%; height: 16px;"></ion-skeleton-text>
          <ion-skeleton-text animated style="width: 40%; height: 16px; margin-top: 6px;"></ion-skeleton-text>
        </ion-label>
        <ion-button fill="clear" slot="end" disabled>
          <ion-skeleton-text animated style="width: 60px; height: 32px;"></ion-skeleton-text>
        </ion-button>
      </ion-item>
    </ion-grid>
  </ion-content>
</ng-template>
